<template>
  <div class="groupContainer">
    <div>
      <div v-for="(group, index) in groups" :key="index+'users_group'" class="d-flex align-items-center">
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-center">
            <span class="labelForSelect">{{ questionLabel }} {{ groups.length > 1 ? index + 1 : ''  }}</span>
            <a v-if="showBtnGroup && !isSelectDisabled" role="button" @click="removeGroup(index)" class="btn-remove-group mb-1">Remove</a>
          </div>
          <div class="">
            <b-form-group
              class="labelForSelect ml-1 col-12 col-md-12"
              :label="$t('action_plan.list.filters.start_date')">
              <flat-pickr
                :id="context.id + 'startDate'"
                v-model="group.startDate"
                :config="datePickerConfig"
                :disabled="isSelectDisabled"
                class="timeNoBackground w-100"
                @input="onChange"
              />
            </b-form-group>
            <b-form-group
              class="labelForSelect ml-1 col-12 col-md-12"
              :label="$t('action_plan.list.filters.end_date')">
              <flat-pickr
                :id="context.id + 'endDate'"
                v-model="group.endDate"
                :config="datePickerConfig"
                :disabled="isSelectDisabled"
                class="timeNoBackground w-100"
                @input="onChange"
              />
            </b-form-group>
            <b-form-group
              class="labelForSelect ml-1 col-12 col-md-12"
              label="Sistemas">
              <v-select
                v-model="group.system"
                :options="systemOptions"
                :filterable="false"
                :multiple="false"
                :clearable="false"
                ref="selectable"
                :placeholder="$t(placeholderTranslation)"
                class="w-100"
                :disabled="isSelectDisabled"
              />
            </b-form-group>
            <b-form-group
              class="labelForSelect ml-1 col-12 col-md-12"
              :label="$t('action_plan.viewer.comments')">
              <b-form-textarea
                id="docsComments"
                v-model="group.comments"
                @input="onChange"
                :disabled="isSelectDisabled"
                rows="2"
                max-rows="4"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <hr>
        </div>
      </div>
    </div>
    <button
      v-if="showBtnGroup && !isSelectDisabled"
      @click="addGroup"
      class="addGroupBtn mt-1"
      type="button" >
        <span>+ Documentación</span>
    </button>
  </div>
</template>

<script>
import {ref, onMounted, computed, watch} from "@vue/composition-api";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    vSelect,
    flatPickr
  },
  props: {
    id: String,
    name: String,
    label: String,
    fieldOptions: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
    context: Object
  },
  setup(props, {}) {
    const placeholderTranslation = 'custom_forms.select_user';
    const d = new Date();
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const defaultData = {
      system: null,
      startDate: `${day}/${month}/${year}`,
      endDate: `${day}/${month}/${year}`,
      comments: null,
    }
    const exFields = props.context.attributes.extraFields
    const questionLabel = props?.fieldOptions?.questionLabel
    const isSelectDisabled = ref(false);
    const groups = ref([{...defaultData}]);
    const showBtnGroup = ref(false);
    const systemOptions = ["CCTV", "Alarmas", "Control de accesos"];
    const datePickerConfig = {
      dateFormat: "d/m/Y",
      allowInput: true,
      locale: {
        firstDayOfWeek: 1,
      },
    };

    onMounted(async () => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      showBtnGroup.value = props?.fieldOptions?.isGroup;
      if (props?.context?.model.length) {
        setDocsValues(props?.context?.model)
      }
    });

    // Watchers
    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );
    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          setDocsValues(newValue)
        }
      },
      { immediate: true }
    );

    function setDocsValues(data) {
      if(!data) return;
      const modelToShow = !showBtnGroup.value && data.length > 1
        ? data.slice(0, 1)
        : data;
      groups.value = modelToShow;
    }

    function onChange() {
      props.context.model =  groups.value;
    }

    function addGroup() {
      groups.value.push({...defaultData})
      props.context.model = null
    }

    function removeGroup(index) {
      groups.value.splice(index, 1);
      props.context.model = groups.value;
    }

    return {
      placeholderTranslation,
      isSelectDisabled,
      groups,
      questionLabel,
      showBtnGroup,
      datePickerConfig,
      systemOptions,
      onChange,
      addGroup,
      removeGroup,
    }
  }
}
</script>
<style scoped lang="scss">
.dark-layout {
  .labelForSelect {
    color: #fff
  }
  .addGroupBtn {
    border-color: #fff;
  }
}
.addGroupBtn {
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.65em;
  margin: 0;
  border-color: #53dac5;
  background-color: #53dac5;
  cursor: pointer;
  font-size: 0.75em;
  color: #fff;
  font-weight: bold;
}
.labelForSelect {
  display: block;
  line-height: 1.5;
  font-size: 0.9em;
  font-weight: 600;
  color: #5e5873;
  text-transform: none !important;
  margin-bottom: 0.4em;
}
.input-group-repeatable-remove {
  background-color: #cecece;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  display: inline-block;
  width: 1.35em;
  height: 1.35em;
  transition: background-color 0.2s;
}
.input-group-repeatable-remove:hover {
  background-color: #dc2c2c;
}

.input-group-repeatable-remove::before,
.input-group-repeatable-remove::after {
  content: "";
  position: absolute;
  left: 50%;
  width: 0.80em;
  height: 0.2em;
  background-color: white;
  transform-origin: center center;
  transition: transform 0.3s ease;
}

.input-group-repeatable-remove::before {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove::after {
  top: 40%;
  transform: translateX(-50%);
}

.input-group-repeatable-remove:hover::before {
  top: 42%;
  transform: translateX(-60%) rotate(45deg);
}

.input-group-repeatable-remove:hover::after {
  top: 42%;
  transform: translateX(-60%) rotate(-45deg);
}
.groupContainer {
  padding: 1em;
  border: 1px solid #efefef;
  border-radius: 0.3em;
}
.timeNoBackground {
  border-radius: 0.3em;
  background-color: transparent;
  margin: 0;
  border-radius: 0.3em;
  border: 1px solid #cecece;
  background-color: transparent;
  padding: 0.75em;
  margin: 0;
}
</style>
